import { AppState } from '@store/state';
import { createSelector } from '@ngrx/store';
import { SnackBarModel } from './snack-bar.model';

export const stateSnackBar = (state: AppState): SnackBarModel => state.snackBar;
export const selectStateSnackBar = createSelector(stateSnackBar, (selectedSnackBar: SnackBarModel) => selectedSnackBar);
